import { useState, useEffect } from 'react'
import { SvgProps } from 'vvs-uikit'

import { FullWidthSvg, HealthValueCircle } from './styles'

const RADIUS = 124.778
const STROKE_WIDTH = 47.4441

const HEALTH_STEPS = [10, 60, 70, 100]
const HEALTH_DASHARRAY = HEALTH_STEPS.map((d, i, ds) => ((d - (ds[i - 1] || 0)) / 100) * 180).flatMap((d, i) =>
  i === 0 ? [d - 0.4] : i === HEALTH_STEPS.length - 1 ? [0.8, d - 0.4] : [0.8, d - 0.8],
)
const SVG_HEALTH_WINDOW_DASHARRAY = [0, 180, ...HEALTH_DASHARRAY, 360]
  .map((d) => (((RADIUS * Math.PI) / 180) * d).toString())
  .join(' ')

const SVG_HEALTH_VALUE_DASHARRAY = [0, 180.25, 179.4, 180]
  .map((d) => (((RADIUS * Math.PI) / 180) * d).toString())
  .join(' ')

const HealthMeterBarSvg: React.FC<{ health: number } & SvgProps> = ({ health, ...props }) => {
  const [healthInternal, setHealthInternal] = useState(0)
  useEffect(() => {
    requestAnimationFrame(() => {
      setHealthInternal(Math.max(Math.min(health ?? 0, 100), 0))
    })
  }, [health])

  return (
    <FullWidthSvg
      width="313"
      height="153"
      viewBox="0 0 313 153"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask id="meter-window" maskUnits="userSpaceOnUse" x="-30" y="0" width="374" height="153">
        <circle
          cx="156.5"
          cy="153.5"
          r={RADIUS}
          stroke="#FFFFFF"
          strokeWidth={STROKE_WIDTH}
          strokeDasharray={SVG_HEALTH_WINDOW_DASHARRAY}
        />
      </mask>
      <g mask="url(#meter-window)">
        <g filter="url(#meter-window-bg)">
          <circle cx="156.5" cy="153.5" r="124.778" stroke="#E2E0DB" strokeWidth="47.4441" />
        </g>

        <HealthValueCircle
          cx="156.5"
          cy="153.5"
          r={RADIUS}
          stroke="#0BD3D8"
          strokeWidth={STROKE_WIDTH}
          strokeDasharray={SVG_HEALTH_VALUE_DASHARRAY}
          health={healthInternal}
        />
      </g>

      <defs>
        <filter
          id="meter-window-bg"
          x="8"
          y="5.00003"
          width="297"
          height="301"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology radius="2" operator="erode" in="SourceAlpha" result="effect1_innerShadow_703_20016" />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_703_20016" />
        </filter>
      </defs>
    </FullWidthSvg>
  )
}

export default HealthMeterBarSvg
